// extracted by mini-css-extract-plugin
export default {"sp":"Loader_sp__-yzdk","spinner":"Loader_spinner__PT5Bi"};